export default "__VITE_ASSET__lIMpOcym__"